import { cn } from '../lib/utils'

function Anchor({ className, ...props }: React.ComponentProps<'a'>) {
  return <a className={cn('underline', className)} {...props} />
}

export { Anchor }
